import React from 'react';

import { formatAsDollars } from '../../../../lib/helpers';
import Tooltip from '../../../utility/Tooltip';

import styles from '../../../../styles/sass/pages/Tools.module.scss';

export interface Props {
  label: string;
  value: any;
  tooltip?: string;
  title?: boolean;
}

const ClosingCostItem = (props: Props) => {
  return (
    <div className={styles.closingCostItemDetails}>
      <div className={props.title ? styles.titleStyle : styles.itemStyle}>
        <p>{props.label}</p>
        {props.tooltip && (
          <div className={styles.tooltip}>
            <Tooltip text={props.tooltip} />
          </div>
        )}
      </div>
      {
        /**
         * TODO: Replace 'react-animated-nuber' with a new package which is REACT 17 compatible.
         * TODO: Replace 'react-animated-number' with a new package which is REACT 17 compatible.
        <AnimatedNumber
          value={props.value}
          style={{
            transition: '0.8s ease-out',
            transitionProperty: 'color, opacity',
            color: props.value === 0 ? '#463264' : '#4A4A4A',
            fontWeight: props.title ? 'bold' : 'normal',
            fontSize: 18,
          }}
          stepPrecision={20}
          duration={1000}
          formatValue={(n: any) => (n == 0 ? '$0' : formatAsDollars(n))}
        />
        */
        <p
          style={{
            transition: '0.8s ease-out',
            transitionProperty: 'color, opacity',
            color: props.value === 0 ? '#463264' : '#4A4A4A',
            fontWeight: props.title ? 'bold' : 'normal',
            fontSize: 18,
          }}
        >
          {props.value ? formatAsDollars(props.value) : '$0'}
        </p>
      }
    </div>
  );
};

export default ClosingCostItem;
